// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-wrapper {
  display: flex;
  padding: var(--spacing-regular);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-small);
  border-radius: var(--spacing-small);
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  margin-bottom: var(--spacing-regular);
}
.card-wrapper .verticalLine {
  border-left: var(--border-width) solid var(--color-neutral-dark);
  height: 100%;
  margin: 16px;
}
.card-wrapper .card-header {
  display: flex;
  gap: var(--spacing-small);
}
.card-wrapper .card-header .date-order {
  color: var(--color-neutral-dark-lighter);
  font-size: var(--font-paragraph);
  font-weight: 600;
  line-height: 20px;
}
.card-wrapper .card-header .amount-itens {
  color: var(--color-neutral-dark);
  font-size: var(--font-paragraph);
  font-weight: 600;
  line-height: 20px;
}
.card-wrapper .card-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}
.card-wrapper .card-content .order-trace .vert-button.ant-btn-link {
  color: #009dff;
  text-decoration-line: underline;
}
.card-wrapper .product-info {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
.card-wrapper .product-info .product-info-header {
  display: flex;
  height: 20px;
  align-items: center;
}
.card-wrapper .product-info .product-info-header .identifier-product {
  color: var(--color-neutral-dark);
  font-size: var(--font-paragraph);
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.card-wrapper .product-info .product-info-header .status-order {
  text-align: center;
  font-size: var(--font-paragraph);
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.card-wrapper .product-info .product-info-header .dot-status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 var(--spacing-small) 0 0;
}
.card-wrapper .product-info .product-info-header .status-order-container {
  display: flex;
  align-items: center;
}
.card-wrapper .product-info .product-info-header .status-order-container.success-color > .dot-status {
  background-color: var(--color-success);
}
.card-wrapper .product-info .product-info-header .status-order-container.success-color > .description-status {
  color: var(--color-success);
}
.card-wrapper .product-info .product-info-header .status-order-container.warning-color > .dot-status {
  background-color: var(--color-warning);
}
.card-wrapper .product-info .product-info-header .status-order-container.warning-color > .description-status {
  color: var(--color-warning);
}
.card-wrapper .product-info .product-info-header .status-order-container.error-color > .dot-status {
  background-color: var(--color-error);
}
.card-wrapper .product-info .product-info-header .status-order-container.error-color > .description-status {
  color: var(--color-error);
}
.card-wrapper .product-info .product-info-header .status-order-container.default-color > .dot-status {
  background-color: var(--color-neutral-dark-lighter);
}
.card-wrapper .product-info .product-info-header .status-order-container.default-color > .description-status {
  color: var(--color-neutral-dark-lighter);
}
.card-wrapper .order-items {
  display: flex !important;
  align-items: center;
  gap: var(--spacing-small);
  flex: 1 0 0;
  max-height: 70px;
}
.card-wrapper .order-items .item-image {
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-neutral-light-lighter);
  border-radius: 100%;
}
.card-wrapper .order-items .item-image img {
  height: 40px;
}
.card-wrapper .order-items .item-infos {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 80%;
  max-width: 300px;
}
.card-wrapper .order-items .item-infos span {
  color: var(--color-neutral-dark);
  font-style: normal;
}
.card-wrapper .order-items .item-infos .item-name {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 20px;
}
.card-wrapper .order-items .item-infos .item-vendor {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 16px;
  width: 400;
}
.card-wrapper .order-items .item-infos .item-quantity {
  font-size: var(--font-paragraph);
  font-weight: 500;
  line-height: 20px;
}
.card-wrapper .order-value-wrapper {
  display: flex;
  width: 200px;
  justify-content: center;
}
.card-wrapper .order-value-wrapper .total-order-value {
  font-size: var(--font-medium);
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
}
.card-wrapper .order-value-wrapper .total-order-value span {
  font-weight: 600;
}
.card-wrapper .VertCarousel-Container {
  width: 400px;
  height: 80px;
}
.card-wrapper .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.prev {
  left: -16px !important;
}
.card-wrapper .VertCarousel-Container .VertCarouselWithCustomNavigationArrow-navigations.next {
  right: -16px !important;
}
.card-wrapper .VertCarousel-Container .vert-carousel {
  width: 90%;
  margin: auto;
  height: 80px;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .card-wrapper .card-content {
    flex-direction: column;
    align-items: unset;
    gap: 16px;
  }
  .card-wrapper .vert-carousel {
    height: unset;
    width: 100%;
  }
  .card-wrapper .order-items {
    max-height: unset;
    align-items: flex-start;
  }
  .card-wrapper .order-items .item-infos .item-name {
    white-space: unset;
    text-overflow: unset;
  }
  .card-wrapper .order-trace {
    display: none;
  }
  .card-wrapper .order-value {
    gap: var(--spacing-small);
  }
  .card-wrapper .order-value .order-value-total {
    font-size: var(--font-medium);
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0em;
    display: block;
    width: 56px;
  }
  .card-wrapper .order-details .order-button-details {
    width: 100%;
  }
  .card-wrapper .VertCarousel-Container {
    height: unset;
  }
  .card-wrapper .VertCarousel-Container .vert-carousel {
    height: unset;
    width: 100%;
  }
  .card-wrapper .VertCarousel-Container .vert-carousel .slick-list {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Orders/OrdersList/OrderCardInfosStyles.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,+BAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mCAAA;EACA,gBAAA;EACA,gDAAA;EACA,qCAAA;AACF;AAVA;EAYI,gEAAA;EACA,YAAA;EACA,YAAA;AACJ;AAfA;EAkBI,aAAA;EACA,yBAAA;AAAJ;AAnBA;EAqBM,wCAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;AACN;AAzBA;EA2BM,gCAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;AACN;AA/BA;EAmCI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AADJ;AArCA;EAyCQ,cAAA;EACA,+BAAA;AADR;AAzCA;EAgDI,aAAA;EACA,sBAAA;EACA,yBAAA;AAJJ;AA9CA;EAqDM,aAAA;EACA,YAAA;EACA,mBAAA;AAJN;AAnDA;EAyDQ,gCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHR;AA1DA;EAiEQ,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAJR;AAjEA;EAwEQ,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;AAJR;AAvEA;EA+EQ,aAAA;EACA,mBAAA;AALR;AAMQ;EAEI,sCAAA;AALZ;AAGQ;EAKI,2BAAA;AALZ;AAQQ;EAEI,sCAAA;AAPZ;AAKQ;EAKI,2BAAA;AAPZ;AAUQ;EAEI,oCAAA;AATZ;AAOQ;EAKI,yBAAA;AATZ;AAYQ;EAEI,mDAAA;AAXZ;AASQ;EAKI,wCAAA;AAXZ;AAnGA;EAsHI,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;AAhBJ;AA1GA;EA6HM,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oDAAA;EACA,mBAAA;AAhBN;AAnHA;EAsIQ,YAAA;AAhBR;AAtHA;EA0IM,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AAjBN;AA9HA;EAiJQ,gCAAA;EACA,kBAAA;AAhBR;AAlIA;EAsJQ,6BAAA;EACA,gBAAA;EACA,iBAAA;AAjBR;AAvIA;EA2JQ,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAjBR;AA7IA;EAiKQ,gCAAA;EACA,gBAAA;EACA,iBAAA;AAjBR;AAlJA;EAyKI,aAAA;EACA,YAAA;EACA,uBAAA;AApBJ;AAvJA;EA8KM,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AApBN;AA7JA;EAoLQ,gBAAA;AApBR;AAhKA;EA0LI,YAAA;EACA,YAAA;AAvBJ;AApKA;EA8LM,sBAAA;AAvBN;AAvKA;EAiMM,uBAAA;AAvBN;AA1KA;EAqMM,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAxBN;AA6BA;EACE;IAEI,sBAAA;IACA,kBAAA;IACA,SAAA;EA5BJ;EAwBA;IAOI,aAAA;IACA,WAAA;EA5BJ;EAoBA;IAWI,iBAAA;IACA,uBAAA;EA5BJ;EAgBA;IAcM,kBAAA;IACA,oBAAA;EA3BN;EAYA;IAmBI,aAAA;EA5BJ;EASA;IAuBI,yBAAA;EA7BJ;EAMA;IAyBM,6BAAA;IACA,gBAAA;IACA,iBAAA;IACA,mBAAA;IACA,cAAA;IACA,WAAA;EA5BN;EAFA;IAoCM,WAAA;EA/BN;EALA;IAwCI,aAAA;EAhCJ;EARA;IA0CM,aAAA;IACA,WAAA;EA/BN;EAZA;IA6CQ,WAAA;EA9BR;AACF","sourcesContent":[".card-wrapper {\n  display: flex;\n  padding: var(--spacing-regular);\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-small);\n  border-radius: var(--spacing-small);\n  background: #fff;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n  margin-bottom: var(--spacing-regular);\n\n  .verticalLine {\n    border-left: var(--border-width) solid var(--color-neutral-dark);\n    height: 100%;\n    margin: 16px;\n  }\n\n  .card-header {\n    display: flex;\n    gap: var(--spacing-small);\n    .date-order {\n      color: var(--color-neutral-dark-lighter);\n      font-size: var(--font-paragraph);\n      font-weight: 600;\n      line-height: 20px;\n    }\n    .amount-itens {\n      color: var(--color-neutral-dark);\n      font-size: var(--font-paragraph);\n      font-weight: 600;\n      line-height: 20px;\n    }\n  }\n\n  .card-content {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: center;\n    .order-trace {\n      .vert-button.ant-btn-link {\n        color: #009dff;\n        text-decoration-line: underline;\n      }\n    }\n  }\n\n  .product-info {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-small);\n\n    .product-info-header {\n      display: flex;\n      height: 20px;\n      align-items: center;\n      .identifier-product {\n        color: var(--color-neutral-dark);\n        font-size: var(--font-paragraph);\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n      }\n\n      .status-order {\n        text-align: center;\n        font-size: var(--font-paragraph);\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n      }\n      .dot-status {\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        margin: 0 var(--spacing-small) 0 0;\n      }\n\n      .status-order-container {\n        display: flex;\n        align-items: center;\n        &.success-color {\n          > .dot-status {\n            background-color: var(--color-success);\n          }\n          > .description-status {\n            color: var(--color-success);\n          }\n        }\n        &.warning-color {\n          > .dot-status {\n            background-color: var(--color-warning);\n          }\n          > .description-status {\n            color: var(--color-warning);\n          }\n        }\n        &.error-color {\n          > .dot-status {\n            background-color: var(--color-error);\n          }\n          > .description-status {\n            color: var(--color-error);\n          }\n        }\n        &.default-color {\n          > .dot-status {\n            background-color: var(--color-neutral-dark-lighter);\n          }\n          > .description-status {\n            color: var(--color-neutral-dark-lighter);\n          }\n        }\n      }\n    }\n  }\n\n  .order-items {\n    display: flex !important;\n    align-items: center;\n    gap: var(--spacing-small);\n    flex: 1 0 0;\n    max-height: 70px;\n\n    .item-image {\n      width: 56px;\n      height: 56px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: var(--color-neutral-light-lighter);\n      border-radius: 100%;\n\n      img {\n        height: 40px;\n      }\n    }\n    .item-infos {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      align-self: stretch;\n      width: 80%;\n      max-width: 300px;\n      span {\n        color: var(--color-neutral-dark);\n        font-style: normal;\n      }\n\n      .item-name {\n        font-size: var(--font-medium);\n        font-weight: 600;\n        line-height: 20px;\n      }\n      .item-vendor {\n        font-size: var(--font-paragraph);\n        font-weight: 400;\n        line-height: 16px;\n        width: 400;\n      }\n      .item-quantity {\n        font-size: var(--font-paragraph);\n        font-weight: 500;\n        line-height: 20px;\n      }\n    }\n  }\n\n  .order-value-wrapper {\n    display: flex;\n    width: 200px;\n    justify-content: center;\n\n    .total-order-value {\n      font-size: var(--font-medium);\n      font-weight: 400;\n      line-height: 20px;\n      letter-spacing: 0em;\n\n      span {\n        font-weight: 600;\n      }\n    }\n  }\n\n  .VertCarousel-Container {\n    width: 400px;\n    height: 80px;\n\n    .VertCarouselWithCustomNavigationArrow-navigations.prev {\n      left: -16px !important;\n    }\n    .VertCarouselWithCustomNavigationArrow-navigations.next {\n      right: -16px !important;\n    }\n\n    .vert-carousel {\n      width: 90%;\n      margin: auto;\n      height: 80px;\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .card-wrapper {\n    .card-content {\n      flex-direction: column;\n      align-items: unset;\n      gap: 16px;\n    }\n    .vert-carousel {\n      height: unset;\n      width: 100%;\n    }\n    .order-items {\n      max-height: unset;\n      align-items: flex-start;\n      .item-infos .item-name {\n        white-space: unset;\n        text-overflow: unset;\n      }\n    }\n    .order-trace {\n      display: none;\n    }\n\n    .order-value {\n      gap: var(--spacing-small);\n      .order-value-total {\n        font-size: var(--font-medium);\n        font-weight: 500;\n        line-height: 20px;\n        letter-spacing: 0em;\n        display: block;\n        width: 56px;\n      }\n    }\n\n    .order-details {\n      .order-button-details {\n        width: 100%;\n      }\n    }\n    .VertCarousel-Container {\n      height: unset;\n      .vert-carousel {\n        height: unset;\n        width: 100%;\n        .slick-list {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
